import Tabs from "../../../../components/Tabs";
import ProductController from "../../../Products/controller/ProductController";
import {get, toNumber} from "lodash";
import AppSettingController from "../../../Main/controller/AppSettingController";
import useWindowSize from "../../../../utility/useWindowSize";
import {useTranslation} from "react-i18next";

export default function LayoutProduct() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting();
    const {width} = useWindowSize();
    const grid_list = [
        {label: t("setting.list")},
        {label: t("setting.grid")},
    ];
    const grid_columns = [
        {label: "1"},
        {label: "2"},
        {label: "3"},
        {label: "4"},
        {label: "5"},
    ];

    if (width <= 768) {
        const indexToRemove = grid_columns.findIndex(item => item.label === "2");
        if (indexToRemove !== -1) {
            grid_columns.splice(indexToRemove + 1);
        }

        if (setting.grid < 2) {
            AppSettingController.changeGridColumns(2)
        }
    }

    return (
        <>
            <div className={"shop-arrangement"}>
                <p>{t("setting.shopArrangement")}</p>
                <div className={'shop-arrangement-selector'}>
                    <Tabs tabs={grid_list} defaultActiveTab={setting.isList ? 0 : 1}
                          onTabChange={() => ProductController.productArrangementToggle()}/>
                </div>
            </div>
            <div className={`grid-template ${!setting.isList ? 'show-grid-template' : ''}`}>
                <p>{t("setting.columnsNumber")}</p>
                <div className={"grid-template-selector"}>
                    <Tabs tabs={grid_columns}
                          defaultActiveTab={setting.grid - 1}
                          onTabChange={(active) => AppSettingController.changeGridColumns(toNumber(get(active, "label")))}/>
                </div>
            </div>
        </>
    )
}